// extracted by mini-css-extract-plugin
export default {"melodyVideo":"QN-z","isFullWidth":"RN-z","landingPageVideo":"SN-z","play":"TN-z","iframeVideo":"UN-z","playHidden":"VN-z","fullwidth":"WN-z"};